<template>
  <div class="h-full min-h-screen md:min-h-0 flex flex-col home">
    <div
      :class="themeIsDark ? 'bg-black text-white' : 'bg-white text-black'"
      class="flex-1 md:overflow-y-scroll"
    >
      <div class="max-h-300 flex justify-center items-start overflow-hidden">
        <NavMenu />
        <img
          class="h-96 md:h-auto w-full object-cover header-img"
          :src="themeHeaderImageUrl"
        />
      </div>
      <div
        :class="themeIsDark ? 'bg-black ' : 'bg-white'"
        class="
          relative
          flex-1
          z-10
          rounded-t-xl
          md:rounded-none
          -mt-4
          py-8
          sm:pt-12
          pb-72
          px-8
          sm:px-44
        "
      >
        <p
          class="text-base md:text-lg text-center mb-6 md:mb-12"
          :style="$themeStyle"
          v-html="$t('homeTitle')"
        >
        </p>
        <figure
          class="
            flex
            justify-center
            items-center
            mb-8
            md:mb-12
            px-10
            md:px-0
            w-full
          "
        >
          <img :src="themeLogoImageUrl" class="logo" />
        </figure>
        <p class="text-base md:text-lg text-center mb-8" :style="$themeStyle" v-html="$t('homeText')">
        </p>
      </div>
    </div>
    <div
      :class="themeIsDark ? 'bg-black ' : 'bg-white'"
      class="
        z-10
        fixed
        bottom-0
        w-full
        flex-1
        p-10
        md:px-0
        md:absolute
        md:bottom-0
        md:py-10
        md:w-full
        md:max-w-4xl
        md:flex
        md:items-center
        md:justify-center
      "
    >
      <div>
        <div class="mb-8 mx-auto sm:w-134">
          <Slide :title="$t('homeSlide')" @onSuccess="onSlide" />
        </div>
        <router-link
          class="text-base text-center block"
          to="onboarding"
          :class="themeIsDark ? 'text-white' : 'text-black'"
        >
          {{ $t("homeLinkHow") }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { TranslationHandler } from '../../mixins/translation-handler'
import { Component, Mixins } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { ThemeHandler } from '../../mixins/theme-handler'

@Component({
  components: {
  }
})
export default class Home extends Mixins(TranslationHandler, ThemeHandler) {
  @Getter themeIsDark!: boolean
  @Getter themeLogoImageUrl!: string
  @Getter themeHeaderImageUrl!: string
  @Action('GO_TO_NEXT_STEP') goToNextStep!: () => void
  @Action('ENSURE_STEP_NAME') ensureStepName!: (stepName: string) => void

  mounted () {
    this.ensureStepName('Home')
  }

  onSlide () {
    this.goToNextStep()
    // this.$router.push('/login')
  }
}

</script>
